import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment';
import WorkPlanModal from "./modules/WorkPlanModal.vue";
import dateSelect from '@/components/date/dateSelect';
import weekSelect from '@/components/date/weekSelect';
import monthSelect from '@/components/date/monthSelect';
import { queryUserTreeList, ajaxGetDictItems } from '@/api/api';
import { accDiv } from '@/utils/util';
var parentWidth = '160px';
var childWidth = '80px';
export default {
  name: 'WaterReport',
  mixins: [JeecgListMixin],
  components: {
    WorkPlanModal: WorkPlanModal,
    dateSelect: dateSelect,
    weekSelect: weekSelect,
    monthSelect: monthSelect
  },
  data: function data() {
    return {
      selectColItem: [],
      minList: {},
      maxList: {},
      avgList: {},
      autoLoadInit: false,
      scroll: {
        y: 500
      },
      columns: [{
        title: '日期',
        label: '日期',
        align: 'center',
        width: 100,
        dataIndex: 'dateStr',
        colName: 'data_time',
        value: 'data_time'
      }],
      selectColumnsList: [],
      url: {
        list: '/om/work/plan/report'
      },
      reportType: '1',
      limitSelectDate: {},
      userId: [],
      tableData: [],
      peopleTreeData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      showColControl: false,
      planType: null
    };
  },
  created: function created() {
    this.loadPeopleTree();
    this.getDictList();
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
    this.loadData(this.reportType);
  },
  watch: {},
  methods: {
    getDictList: function getDictList() {
      var _this = this;

      ajaxGetDictItems('plan_type').then(function (res) {
        _this.planType = res.result;
      });
    },
    getDictText: function getDictText(id) {
      var name = '';
      this.planType.forEach(function (item) {
        if (item.value == id) {
          name = item.title;
        }
      });
      return name;
    },
    onChange: function onChange(e) {
      var col = [];
      this.selectColumnsList.forEach(function (item) {
        if (e.indexOf(item.value) != -1) {
          col.push(item);
        }
      });
      this.columns = [].concat(col);
    },
    onClose: function onClose() {
      this.showColControl = false;
    },
    loadPeopleTree: function loadPeopleTree() {
      var that = this;
      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.peopleTreeData = res.result;
        }
      });
    },
    searchQuery: function searchQuery() {
      // this.queryParam.users = this.userId.toString()
      this.loadData(this.reportType);
    },
    // 渲染列
    renderCol: function renderCol(record, param) {
      var _this2 = this;

      var h = this.$createElement;
      var result = record[param];
      var res = [];

      if (record.dateStr == '完成率') {
        res.push(h("p", {
          "style": "text-align:center"
        }, [result[0] == 0 && result[1] == 0 ? 0 : accDiv(result[0], result[1]) * 100, "%(", result[0], "/ ", result[1], ")"]));
      } else {
        result.forEach(function (item, index) {
          // if (item.status == 1) {
          res.push(h("p", {
            "style": "text-align:left"
          }, [index + 1, "\u3001", h("a-tag", {
            "style": "margin-right:10px"
          }, [item.detailTitle]), h("a", {
            "attrs": {
              "click": "toPlan"
            },
            "style": "color:#000;text-align:center",
            "on": {
              "click": function click(e) {
                return _this2.toPlan(item);
              }
            }
          }, [item.title, "(", item.siteName, ")"])])); // } else if (item.status == 2) {
          //   res.push(
          //     <p style="text-align:left">
          //       {index + 1}、<a-tag style="margin-right:10px">{this.getDictText(item.type)}</a-tag>
          //       <s style="color:#ccc;text-align:center" onClick={(e) => this.toPlan(item)}>
          //         {item.title}
          //       </s>
          //       <a-icon style="color:green;margin-left:10px;font-size:18px;" theme="filled" type="check-circle" />
          //     </p>
          //   )
          // }
        });
      }

      return res;
    },
    loadData: function loadData(type) {
      var _this3 = this;

      console.log('loadData', this.queryParam);

      if (!this.queryParam.stime || !this.queryParam.etime) {
        this.$message_custom('请选择时间', 'error');
        return;
      }

      this.queryParam.type = type; // var params = this.getQueryParams() //查询条件

      this.loading = true;
      this.dataSource = [];
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, this.queryParam).then(function (res) {
        if (res.success) {
          var colunmns = [{
            title: '日期',
            align: 'center',
            width: 120,
            dataIndex: 'dateStr',
            colName: 'data_time'
          }];
          var dataSource = res.result.data;
          var users = res.result.user;
          _this3.parentWidth = accDiv(1300, users.length) + 'px';
          users.forEach(function (element) {
            var param = {
              title: element.realname,
              align: 'center',
              width: parentWidth,
              dataIndex: 'user_' + element.id,
              colName: 'user_' + element.id,
              customRender: function customRender(text, record, index) {
                return _this3.renderCol(record, 'user_' + element.id);
              }
            };
            colunmns.push(param);
          });
          _this3.dataSource = dataSource;

          _this3.dataSource.push(res.result.avg);

          console.log('colunmns', colunmns);
          console.log('dataSource', _this3.dataSource);
          _this3.selectColItem = [];
          colunmns.forEach(function (item) {
            item.label = item.title;
            item.value = item.colName;

            _this3.selectColItem.push(item.colName);
          });
          _this3.columns = [].concat(colunmns);
          _this3.selectColumnsList = [].concat(colunmns); //console.log(this.columns)
        }

        if (res.code === 510) {
          _this3.$message_custom(res.message, 'warning');
        }

        _this3.loading = false;
      });
    },
    toPlan: function toPlan(record) {
      var _this4 = this;

      getAction("om/work/plan/".concat(record.id), {}).then(function (res) {
        if (res.success) {
          _this4.$refs.workPlan.disableSubmit = true;

          _this4.$refs.workPlan.edit(res.result);

          _this4.$refs.workPlan.title = '办理:工作计划';
          _this4.$refs.workPlan.isOK = res.result.status == 1 ? true : false;
        } else {}
      });
    },
    // 周变化
    weekChange: function weekChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
      console.log('月变化', value);
    },
    // 报表类型变化
    reportTypeChange: function reportTypeChange(e) {
      this.reportType = e.target.value;

      if (this.reportType == '3') {
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
      }
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    }
  }
};